/**
 * ## Login component
 *
 * @module src/component/login
 */

"use strict";

const conf = require("../../config");
const layout = require("../layout");
const l = require("../../common").localization;

const init = (options, callback) => {
  $("#login_logo").css("display", "block");
  TweenMax.to("#login_logo", 0, {
    alpha: 0,
    scale: 0.8,
    ease: Power2.easeOut,
  });
  TweenMax.to("#login_logo", conf.vars.interfaceSpeed * 2, {
    alpha: 1,
    scale: 1,
    ease: Power2.easeOut,
  });
  $("#login_logo").css("display", "block");
  TweenMax.to("#login_credentials", 1, {
    height: 220,
    delay: conf.vars.interfaceSpeed * 2,
    ease: Power2.easeOut,
  });
  $("#login_submit").fastClick((e) => {
    doLogin(callback);
  });
  $("#login_username, #login_password").keypress((e) => {
    if (e.which == 13) {
      $("#login_submit").click();
      return false;
    }
  });

  const host = window.location.host.replace("guestlist", "guestlistdashboard");
  if (conf.vars.NODE_ENV.indexOf("ios") > -1) {
    $("#login_forget").fastClick((e) => {
      window.open("https://guestlist.heartland.us/reset.html", "_system");
    });
    $("#manager_dashboard").fastClick((e) => {
      window.open("https://guestlistdashboard.heartland.us", "_system");
    });
  } else if (conf.vars.NODE_ENV.indexOf("android") > -1) {
    $("#login_forget").fastClick((e) => {
      navigator.app.loadUrl("https://guestlist.heartland.us/reset.html", {
        openExternal: true,
      });
    });
    $("#manager_dashboard").fastClick((e) => {
      navigator.app.loadUrl("https://guestlistdashboard.heartland.us", {
        openExternal: true,
      });
    });
  } else {
    $("#login_forget").fastClick((e) => {
      window.open(`https://${window.location.host}/reset.html`, "_blank");
    });
    $("#manager_dashboard").fastClick((e) => {
      window.open(`https://${host}`, "_blank");
    });
  }
  $("#footer_version").html(`${l.translate("version")} ${conf.vars.VERSION}`);
};

const doLogin = (callback) => {
  layout.hideKeyboard();
  const data = {
    username: $("#login_username").val(),
    password: $("#login_password").val(),
  };
  callback(null, data);
};

const check = (data, callback) => {
  layout.hideKeyboard();
  $.ajax({
    url: `${conf.vars.API_ROOT}/login`,
    type: "POST",
    data: JSON.stringify(data),
    contentType: "application/json",
    success: (result) => {
      callback(null, result);
    },
    error: (jqXHR, textStatus, errorThrown) => {
      callback(null, { status: "error" });
    },
    timeout: 10000,
  });
};

const shake = () => {
  TweenMax.to("#login_main", 0.1, {
    x: "+=40",
    ease: Power2.easeOut,
  });
  TweenMax.to("#login_main", 0.1, {
    x: "-=80",
    ease: Power2.easeOut,
    delay: 0.1,
  });
  TweenMax.to("#login_main", 0.1, {
    x: "+=80",
    ease: Power2.easeOut,
    delay: 0.2,
  });
  TweenMax.to("#login_main", 0.1, {
    x: "-=80",
    ease: Power2.easeOut,
    delay: 0.3,
  });
  TweenMax.to("#login_main", 0.1, {
    x: "+=40",
    ease: Power2.easeOut,
    delay: 0.4,
  });
};

const close = () => {
  TweenMax.to("#login_bg", conf.vars.interfaceSpeed, {
    height: 0,
    ease: Power2.easeOut,
    delay: 0.5,
    onComplete: block,
  });
  TweenMax.to("#login_main", conf.vars.interfaceSpeed, {
    alpha: 0,
    ease: Power2.easeIn,
  });
};

const block = () => {
  $("#login_main").css("display", "none");
  $("#login_bg").css("display", "none");
};

module.exports = {
  init,
  check,
  shake,
  close,
  block,
};



/** WEBPACK FOOTER **
 ** ./src/components/login/index.js
 **/